<template>
<div>
    <v-footer :inset="footer.inset" app color="footerback" dark>
        <v-spacer></v-spacer>
        <div>Extraservices &copy; {{ new Date().getFullYear() }}</div>
        <v-spacer></v-spacer>
        <v-tooltip top>
            <template v-slot:activator="{ on }">
                <v-btn icon @click.stop="sheet = !sheet" v-on="on">
                    <v-icon>mdi-email</v-icon>
                </v-btn>
            </template>
            <span>Написати нам</span>
        </v-tooltip>
    </v-footer>
    <div class="text-center">
        <v-bottom-sheet v-model="sheet" inset>
            <v-sheet class="text-center">
                <v-btn icon class="mt-6" @click="sheet = !sheet">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-container fluid>
                    <v-layout align-center justify-center>
                        <v-flex sm12 sm8 md8>
                            <ValidationObserver ref="obs" v-slot="{ invalid, validated, passes, validate }">
                                <material-card class="text-center title font-weight-bold" color="cardheaderdark" title="Написати нам" :text="!$vuetify.breakpoint.smAndDown ? 'Ваше звернення буде опрацьовано протягом доби':''">
                                    <v-container :style="$vuetify.breakpoint.smAndDown ? 'max-height: 300px':'max-height: 800px'" class="overflow-y-auto">
                                        <v-card-text>
                                            <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>
                                            <v-form>
                                                <validation-provider v-slot="{ errors, valid }" rules="required|tel">
                                                    <v-text-field :success="valid" persistent-hint hint="Введiть телeфон користувача" prepend-icon="mdi-phone" name="phone" label="Телефон" placeholder="+38(000) 000 - 0000" v-mask="maskTel" v-model="f.phone"></v-text-field>
                                                </validation-provider>
                                                <validation-provider v-slot="{ errors, valid }" rules="required|email">
                                                    <v-text-field :success="valid" :error-messages="errors" hint="Введiть Ваш Email" prepend-icon="mdi-email" name="email" label="Email" v-model="f.email"></v-text-field>
                                                </validation-provider>
                                                <validation-provider v-slot="{ errors, valid }" rules="required">
                                                    <v-autocomplete v-model="f.type" :items="types" label="Тема звернення" persistent-hint prepend-icon="mdi-format-list-bulleted-type"></v-autocomplete>
                                                </validation-provider>
                                                <validation-provider v-slot="{ errors, valid }" rules="required">
                                                    <v-textarea clearable prepend-icon="mdi-comment" clear-icon="mdi-cancel" label="Текст звернення" v-model="f.body"></v-textarea>
                                                </validation-provider>

                                            </v-form>

                                        </v-card-text>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn color="cardheaderdark" text @click="passes(submitForm)" :disabled="invalid || !validated">Надiслати</v-btn>
                                            <v-spacer></v-spacer>
                                        </v-card-actions>
                                    </v-container>

                                </material-card>
                            </ValidationObserver>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-sheet>
        </v-bottom-sheet>
    </div>

</div>
</template>

<script>
import {
    mask
} from 'vue-the-mask'

import {
    mapActions
} from 'vuex'

import {
    ValidationObserver,
    ValidationProvider
} from "vee-validate"

export default {
    directives: {
        mask
    },
    components: {
        ValidationProvider,
        ValidationObserver
    },

    data() {
        return {
            loading: false,
            types: [{
                    value: 'Технiчнi',
                    text: 'Технiчнi'
                },
                {
                    value: 'Партнерство та Реклама',
                    text: 'Партнерство та Реклама'
                },
                {
                    value: 'Iншi',
                    text: 'Iншi'
                },
            ],
            maskTel: '+38(###) ###-####',
            sheet: false,
            f: {},
            footer: {
                inset: true,
            },

        }
    },
    methods: {
        ...mapActions(['sendEmailRequest']),
        async submitForm() {
            this.errorMessage = ''
            this.loading = true
            // Execute reCAPTCHA with action "send-request".
            await this.$recaptchaLoaded()
            this.f.reCAPTCHA = await this.$recaptcha('send_request')

            this.sendEmailRequest(this.f)
                .then(
                    d => {
                        this.loading = false
                        this.f = {}
                        this.sheet = false
                    }
                )
                .catch(
                    error => {
                        this.loading = false
                    }
                )
        }
    }
}
</script>

<style>
</style>
